module.exports = "/_next/static/images/AvatarSample-f01554e26e6549275315e54362fb4036.png";